import axios from 'axios'
import {
  CASH_BALANCES_AVAILABLE_API,
  WITH_CREDENTIALS_CONFIG,
} from './constants'

export const getAmountAvailableApi = (accountNumber: string) =>
  axios.get(
    `${CASH_BALANCES_AVAILABLE_API}/available/${accountNumber}`,
    WITH_CREDENTIALS_CONFIG
  )
